export default __webpack_public_path__ + "static/media/comingSoon.bce8bb08.jpg";